/*
  Comparator (snippets/compare-popup.liquid, sections/compare-item.liquid,
  assets/compare.css). Vanilla; replaces compare-product.js.
  - Choosing: the cards' button (.compare[data-pid], product-grid-item
    and the like: its markup doesn't change) and the product page's link
    ([data-compare-toggle], product-details.liquid). A second click takes
    the piece out. Up to "Máximo de piezas"; past it, the bar (or, on
    phones, the notice) says so.
  - Saved in this browser (localStorage cdaCompare: handle, title and
    photo, so the bar is drawn without asking Shopify), so the bar follows
    from page to page, and across tabs. The old list (key "compare") is
    deleted.
  - The bar (from 768px): the photos (each one with an X), "Limpiar"
    and "Comparar (n)", from 2 pieces. Not on the cart page. While it
    shows, <html> has cmp-bar-on and --cmp-bar-h (its height), for the
    footer (compare.css).
  - Phones (below 768px, no bar): the icon in the mobile header
    ([data-compare-header]: hidden without pieces, the count and the
    label) opens the view, also with one piece (it says to choose
    another one); and a notice below the header ([data-compare-toast],
    3 seconds) after adding (with "Comparar (n)") or taking out a
    piece; a tap opens the view. "Limpiar" is in the view.
  - The view: a <dialog> opened with showModal(), like the mini cart.
    One request per piece to sections/compare-item.liquid on the
    product's URL (kept while the page is open); a product that no longer
    exists leaves the list. The cards go on top and, below, a row per
    datum ([data-compare-row]): a row empty in every piece doesn't show,
    an empty value shows "—". "Solo diferencias" hides the rows that are
    the same in every piece and marks the others.
  - "Agregar" closes the view and adds the piece as the cards do
    (Shopify.addItem, cart.api.js), so it follows "Al agregar una pieza"
    of the mini cart.
  - Cards added after the page loads (filters, tabs, related products)
    are marked by a MutationObserver.
*/
(function () {
  'use strict';

  var KEY = 'cdaCompare';
  var SECTION = 'compare-item';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var supported = typeof window.HTMLDialogElement === 'function';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TOGGLES = '.compare[data-pid], [data-compare-toggle]';

  var config = {};
  try {
    config = JSON.parse(document.getElementById('CompareConfig').textContent) || {};
  } catch (e) {}
  var max = Math.max(2, parseInt(config.max, 10) || 3);
  var phone = window.matchMedia ? window.matchMedia('(max-width: 767.98px)') : { matches: false };
  var toastTimer = 0;

  var cache = {};
  var notice = '';
  var lastFocus = null;

  // The old comparator's list (compare-product.js), never read again
  try { window.localStorage.removeItem('compare'); } catch (e) {}

  function load() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(saved)) return [];
      return saved.filter(function (piece) {
        return piece && typeof piece.handle === 'string' && piece.handle;
      }).slice(0, max);
    } catch (e) {
      return [];
    }
  }

  function save() {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  var list = load();

  function indexOf(handle) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) return i;
    }
    return -1;
  }

  // A short bump (compare.css .cmp-bump, header.css .is-bump), restarted
  // when it's already running; nothing with reduced motion
  function bump(el, className) {
    if (!el || reduceMotion) return;
    el.classList.remove(className);
    void el.offsetWidth;
    el.classList.add(className);
    el.addEventListener('animationend', function () { el.classList.remove(className); }, { once: true });
  }

  // Full (the maximum, a piece not chosen): the icon dark red and a short
  // shake (compare.css .cmp-full); the red for 1.2 seconds. With reduced
  // motion, only the red (compare.css)
  function flagFull(button) {
    window.clearTimeout(button.cmpFullTimer);
    button.classList.remove('cmp-full');
    void button.offsetWidth;
    button.classList.add('cmp-full');
    button.cmpFullTimer = window.setTimeout(function () { button.classList.remove('cmp-full'); }, 1200);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // [cantidad], [maximo] and [nombre] in the texts of the settings
  function fill(template, values) {
    return String(template || '')
      .replace(/\[cantidad\]/g, values.cantidad)
      .replace(/\[maximo\]/g, values.maximo)
      .replace(/\[nombre\]/g, values.nombre);
  }

  function announce(message) {
    var box = document.querySelector('[data-compare-status]');
    if (!box) return;
    box.textContent = '';
    window.setTimeout(function () { box.textContent = message || ''; }, 50);
  }

  function dialog() {
    return document.getElementById('CompareDialog');
  }

  // ---- The bar ---------------------------------------------------------------

  // The count of the bar's button, to bump it when it changes (not on load)
  var barCount = null;

  // "Comparar ([cantidad])" with the number in its own span
  function openLabel(bumped) {
    return String(config.open || '').split('[cantidad]').map(escapeHtml)
      .join('<span class="cmp-bar__count' + (bumped ? ' cmp-bump' : '') + '">' + list.length + '</span>');
  }

  var X = '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';

  function renderBar() {
    var bar = document.getElementById('CompareBar');
    if (!bar) return;
    var show = list.length > 0 && !document.body.classList.contains('template-cart');
    var hadFocus = bar.contains(document.activeElement);
    bar.hidden = !show;
    document.documentElement.classList.toggle('cmp-bar-on', show);
    var bumped = barCount !== null && barCount !== list.length && !reduceMotion;
    barCount = list.length;
    if (!show) {
      bar.innerHTML = '';
      return;
    }
    var items = list.map(function (piece) {
      var name = piece.title || piece.handle;
      return '<li class="cmp-bar__item" title="' + escapeHtml(name) + '">' +
        '<span class="cmp-bar__thumb">' + (piece.image ? '<img src="' + escapeHtml(piece.image) + '" alt="" width="44" height="44" loading="lazy">' : '') + '</span>' +
        '<button type="button" class="cmp-bar__remove" data-compare-remove="' + escapeHtml(piece.handle) + '" aria-label="' + escapeHtml((config.remove || '') + ': ' + name) + '">' + X + '</button>' +
        '</li>';
    }).join('');
    for (var i = list.length; i < max; i++) {
      items += '<li class="cmp-bar__item cmp-bar__item--empty" aria-hidden="true"></li>';
    }
    var message = notice || (list.length < 2 ? config.one : '');
    bar.innerHTML =
      '<ul class="cmp-bar__items" role="list">' + items + '</ul>' +
      (message ? '<p class="cmp-bar__msg">' + escapeHtml(message) + '</p>' : '') +
      '<div class="cmp-bar__actions">' +
      '<button type="button" class="cmp-bar__clear" data-compare-clear>' + escapeHtml(config.clear) + '</button>' +
      '<button type="button" class="cmp-bar__open" data-compare-open' + (list.length < 2 ? ' disabled' : '') + '>' +
      openLabel(bumped) + '</button>' +
      '</div>';
    setBarHeight();
    if (hadFocus) {
      var target = bar.querySelector('.cmp-bar__open:not([disabled])') || bar.querySelector('.cmp-bar__clear');
      if (target) target.focus({ preventScroll: true });
    }
  }

  function setBarHeight() {
    var bar = document.getElementById('CompareBar');
    if (bar && !bar.hidden) {
      document.documentElement.style.setProperty('--cmp-bar-h', bar.offsetHeight + 'px');
    }
  }

  // The cards' buttons and the product page's link: marked while chosen.
  // The cards' button is an <a href="#"> with only an icon: a toggle button
  // for screen readers, named after its tooltip (the theme's tooltip moves
  // the title to data-original-title)
  function syncButtons() {
    Array.prototype.forEach.call(document.querySelectorAll(TOGGLES), function (button) {
      var on = indexOf(button.getAttribute('data-pid')) > -1;
      button.classList.toggle('added', on);
      if (!button.hasAttribute('data-compare-toggle')) {
        button.setAttribute('role', 'button');
        if (!button.hasAttribute('aria-label')) {
          var label = button.getAttribute('title') || button.getAttribute('data-original-title');
          if (label) button.setAttribute('aria-label', label);
        }
      }
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    // The mobile header's icon: only with a piece
    Array.prototype.forEach.call(document.querySelectorAll('[data-compare-header]'), function (button) {
      button.hidden = !list.length;
      button.setAttribute('aria-label', fill(config.open, { cantidad: list.length }));
      var count = button.querySelector('[data-compare-count]');
      if (!count) return;
      var changed = count.textContent !== String(list.length);
      count.textContent = list.length;
      if (changed && synced) bump(count, 'is-bump');
    });
    synced = true;
  }

  // The header's count bumps when it changes, not on the first sync
  var synced = false;

  function update() {
    save();
    renderBar();
    syncButtons();
  }

  // Title and photo: the button's data-title / data-image (product page),
  // or the card's (popup_cart_title / popup_cart_image)
  function infoFrom(button) {
    var title = button.getAttribute('data-title') || '';
    var image = button.getAttribute('data-image') || '';
    var card = button.closest('.product-item');
    if (card && !title) {
      var name = card.querySelector('.popup_cart_title');
      if (name) title = name.textContent.trim();
    }
    if (card && !image) {
      var img = card.querySelector('img.popup_cart_image');
      if (img) image = img.getAttribute('data-src') || img.getAttribute('src') || '';
    }
    return { handle: button.getAttribute('data-pid'), title: title, image: image };
  }

  function toggle(button) {
    var piece = infoFrom(button);
    if (!piece.handle) return;
    notice = '';
    var at = indexOf(piece.handle);
    var message = '';
    var link = false;
    // A piece in or out: the button bumps (on the product page, its icon)
    var used = button.querySelector('.pd-compare__icon') || button;
    if (at > -1) {
      bump(used, 'cmp-bump');
      list.splice(at, 1);
      message = config.toastRemoved;
      announce(fill(config.removed, { nombre: piece.title }));
    } else if (list.length >= max) {
      flagFull(button);
      notice = fill(config.full, { maximo: max });
      message = notice;
      announce(notice);
    } else {
      bump(used, 'cmp-bump');
      list.push(piece);
      message = config.toastAdded;
      link = true;
      announce(fill(config.added, { nombre: piece.title }));
    }
    update();
    toast(message, link);
  }

  // Phones: a short notice below the header (the bar doesn't show there)
  function toast(message, link) {
    var box = document.querySelector('[data-compare-toast]');
    if (!box || !phone.matches || !message) return;
    box.querySelector('[data-compare-toast-text]').textContent = message;
    var more = box.querySelector('[data-compare-toast-open]');
    more.hidden = !link;
    more.textContent = fill(config.open, { cantidad: list.length });
    var header = document.querySelector('.site-header-m');
    var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    box.style.top = (top + 8) + 'px';
    box.hidden = false;
    void box.offsetWidth; // shown first, then the slide
    box.classList.add('is-shown');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(hideToast, 3000);
  }

  function hideToast() {
    var box = document.querySelector('[data-compare-toast]');
    if (!box || box.hidden) return;
    box.classList.remove('is-shown');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { box.hidden = true; }, reduceMotion ? 0 : 250);
  }

  function remove(handle) {
    var at = indexOf(handle);
    if (at < 0) return;
    var name = list[at].title || handle;
    list.splice(at, 1);
    notice = '';
    update();
    announce(fill(config.removed, { nombre: name }));
  }

  // ---- The view --------------------------------------------------------------

  function open() {
    var d = dialog();
    if (!d || !supported || !list.length) return;
    if (!d.open) {
      lastFocus = document.activeElement;
      d.showModal();
      document.documentElement.classList.add('cmp-open');
      var x = d.querySelector('.cmp-dialog__close');
      if (x) x.focus({ preventScroll: true });
      void d.offsetWidth; // closed position first, then the slide
      d.classList.add('is-open');
    }
    build();
  }

  function close(now) {
    var d = dialog();
    if (!d || !d.open) return;
    d.classList.remove('is-open');
    if (now || reduceMotion) {
      d.close();
      return;
    }
    window.setTimeout(function () {
      if (d.open && !d.classList.contains('is-open')) d.close();
    }, 300);
  }

  // Esc: animated like the X. 'close' (also when the browser closes it at
  // once): the cleanup. Neither event bubbles: listened in capture.
  document.addEventListener('cancel', function (event) {
    if (event.target !== dialog()) return;
    event.preventDefault();
    close();
  }, true);
  document.addEventListener('close', function (event) {
    if (event.target !== dialog()) return;
    event.target.classList.remove('is-open');
    document.documentElement.classList.remove('cmp-open');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }, true);

  function fetchPiece(handle) {
    if (cache[handle]) return Promise.resolve({ status: 'ok', el: cache[handle] });
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTION, { credentials: 'same-origin' })
      .then(function (response) {
        if (response.status === 404) return { status: 'gone' };
        if (!response.ok) return { status: 'error' };
        return response.text().then(function (html) {
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-compare-item]');
          if (!el) return { status: 'gone' };
          cache[handle] = el;
          return { status: 'ok', el: el };
        });
      })
      .catch(function () { return { status: 'error' }; });
  }

  function build() {
    var d = dialog();
    var body = d && d.querySelector('[data-compare-body]');
    if (!body) return;
    var diff = d.querySelector('[data-compare-diff]');
    diff.hidden = true;
    diff.setAttribute('aria-pressed', 'false');
    body.setAttribute('aria-busy', 'true');
    body.innerHTML = '<div class="cmp-loading" style="--cmp-n: ' + list.length + ';">' +
      list.map(function () { return '<span class="cmp-loading__card"></span>'; }).join('') + '</div>';

    var handles = list.map(function (piece) { return piece.handle; });
    Promise.all(handles.map(fetchPiece)).then(function (results) {
      if (!d.open) return;
      var pieces = [];
      var failed = false;
      results.forEach(function (result, i) {
        if (result.status === 'ok') {
          pieces.push(result.el);
          // Keep the bar's title and photo up to date
          var at = indexOf(handles[i]);
          if (at > -1) {
            list[at].title = result.el.getAttribute('data-title') || list[at].title;
            list[at].image = result.el.getAttribute('data-image') || list[at].image;
          }
        } else if (result.status === 'gone') {
          var gone = indexOf(handles[i]);
          if (gone > -1) list.splice(gone, 1);
        } else {
          failed = true;
        }
      });
      update();
      body.removeAttribute('aria-busy');
      draw(body, diff, pieces, failed);
    });
  }

  function draw(body, diff, pieces, failed) {
    body.innerHTML = '';
    if (failed) {
      var error = document.createElement('p');
      error.className = 'cmp-note';
      error.textContent = config.error || '';
      body.appendChild(error);
    }
    // One piece (phones: the header's icon opens the view with one): the
    // note, and its card, to take it out
    if (pieces.length < 2) {
      var one = document.createElement('p');
      one.className = 'cmp-note';
      one.textContent = config.one || '';
      body.appendChild(one);
      if (!pieces.length) return;
    }

    var scroll = document.createElement('div');
    scroll.className = 'cmp-scroll';
    var table = document.createElement('div');
    table.className = 'cmp-table cmp-table--n' + pieces.length;
    table.setAttribute('role', 'table');
    table.setAttribute('aria-labelledby', 'CompareTitle');
    table.style.setProperty('--cmp-n', pieces.length);

    // The cards; in the corner above the labels (desktop), the count and
    // a second "Solo diferencias" (phones use the one in the header)
    var head = row('cmp-row cmp-row--head');
    var corner = cell('cmp-row__label', 'cell');
    var count = document.createElement('p');
    count.className = 'cmp-corner__count';
    count.textContent = fill(pieces.length === 1 ? config.countOne : config.countOther, { cantidad: pieces.length });
    corner.appendChild(count);
    var cornerDiff = document.createElement('button');
    cornerDiff.type = 'button';
    cornerDiff.className = 'cmp-dialog__diff';
    cornerDiff.setAttribute('data-compare-diff', '');
    cornerDiff.setAttribute('aria-pressed', 'false');
    cornerDiff.textContent = diff.textContent.trim();
    cornerDiff.hidden = true;
    corner.appendChild(cornerDiff);
    head.appendChild(corner);
    pieces.forEach(function (piece) {
      var box = cell('cmp-cell', 'columnheader');
      box.appendChild(document.importNode(piece.querySelector('.cmp-item__card'), true));
      head.appendChild(box);
    });
    table.appendChild(head);

    // The rows, in the order of the first piece; a row empty in every
    // piece doesn't show
    var differs = 0;
    Array.prototype.forEach.call(pieces[0].querySelectorAll('[data-compare-row]'), function (first) {
      var key = first.getAttribute('data-compare-row');
      var values = pieces.map(function (piece) {
        var dd = piece.querySelector('[data-compare-row="' + key + '"] dd');
        return dd ? dd.textContent.replace(/\s+/g, ' ').trim() : '';
      });
      if (!values.some(Boolean)) return;
      var same = values.every(function (value) { return value.toLowerCase() === values[0].toLowerCase(); });
      if (!same) differs++;
      var line = row('cmp-row ' + (same ? 'is-same' : 'is-diff'));
      var label = cell('cmp-row__label', 'rowheader');
      label.textContent = first.querySelector('dt').textContent.trim();
      line.appendChild(label);
      values.forEach(function (value) {
        var box = cell('cmp-cell' + (value ? '' : ' is-empty'), 'cell');
        box.textContent = value || '—';
        line.appendChild(box);
      });
      table.appendChild(line);
    });

    scroll.appendChild(table);
    body.appendChild(scroll);
    diff.hidden = differs === 0;
    cornerDiff.hidden = differs === 0;
  }

  function row(className) {
    var el = document.createElement('div');
    el.className = className;
    el.setAttribute('role', 'row');
    return el;
  }

  function cell(className, role) {
    var el = document.createElement('div');
    el.className = className;
    el.setAttribute('role', role);
    return el;
  }

  // ---- Clicks ------------------------------------------------------------------

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;

    var toggleButton = target.closest(TOGGLES);
    if (toggleButton) {
      event.preventDefault();
      toggle(toggleButton);
      return;
    }

    var removeButton = target.closest('[data-compare-remove]');
    if (removeButton) {
      var inView = !!removeButton.closest('#CompareDialog');
      remove(removeButton.getAttribute('data-compare-remove'));
      if (inView) {
        if (!list.length) {
          close();
        } else {
          build();
          var x = document.querySelector('#CompareDialog .cmp-dialog__close');
          if (x) x.focus({ preventScroll: true });
        }
      }
      return;
    }

    if (target.closest('[data-compare-clear]')) {
      list = [];
      notice = '';
      update();
      close();
      announce(config.cleared);
      return;
    }

    if (target.closest('[data-compare-toast]')) {
      hideToast();
      open();
      return;
    }

    if (target.closest('[data-compare-open]')) {
      open();
      return;
    }

    if (target.closest('[data-compare-close]')) {
      close();
      return;
    }

    var diff = target.closest('[data-compare-diff]');
    if (diff) {
      var on = diff.getAttribute('aria-pressed') !== 'true';
      Array.prototype.forEach.call(document.querySelectorAll('#CompareDialog [data-compare-diff]'), function (button) {
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var table = document.querySelector('#CompareDialog .cmp-table');
      if (table) table.classList.toggle('is-diff-only', on);
      return;
    }

    // "Agregar": close the view at once (the "Agregado al carrito" window
    // would stay under it), then add as the cards do
    var add = target.closest('[data-compare-add]');
    if (add) {
      var id = parseInt(add.getAttribute('data-compare-add'), 10);
      if (!id) return;
      close(true);
      if (window.Shopify && typeof Shopify.addItem === 'function') {
        Shopify.addItem(id, 1);
      } else {
        window.location.href = root + 'cart/add?id=' + id + '&quantity=1';
      }
    }
  });

  // Another tab changed the list
  window.addEventListener('storage', function (event) {
    if (event.key !== KEY) return;
    list = load();
    notice = '';
    renderBar();
    syncButtons();
  });

  window.addEventListener('resize', setBarHeight);

  // Cards added later (filters, tabs, related products, quick view)
  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        syncButtons();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  renderBar();
  syncButtons();
})();
